export function getDayName(date) {
    const dayTable = {
        1: 'Pondělí',
        2: 'Úterý',
        3: 'Středa',
        4: 'Čtvrtek',
        5: 'Pátek',
        6: 'Sobota',
        0: 'Neděle',
    };
    if (date instanceof Date) {
        const day = date.getDay();
        return dayTable[day];
    }
    return null;
}
export function formatDate(value, displayDayName = false) {
    if (typeof value !== 'string')
        return null;
    const date = new Date(value);
    let month = String(date.getUTCMonth() + 1);
    let day = String(date.getUTCDate());
    const year = String(date.getUTCFullYear());
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (displayDayName) {
        const dayName = getDayName(date);
        if (dayName) {
            return [day, month, year].join('.') + ', ' + dayName;
        }
    }
    return [day, month, year].join('.');
}
export function ymdToDmy(value) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!value.match(regEx))
        return null;
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
}
export function ymdToDmySpaces(value) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!value.match(regEx))
        return null;
    const [year, month, day] = value.split('-');
    return `${Number(day)}. ${Number(month)}. ${year}`;
}
export function dateRange(from, to) {
    if (!from && !to)
        return '';
    if (from && !to)
        return `od ${ymdToDmy(from)}`;
    if (!from && to)
        return `do ${ymdToDmy(to)}`;
    if (from && to)
        return `${ymdToDmy(from)}-${ymdToDmy(to)}`;
}
export function getCurrentDateObj() {
    return new Date();
}
export function getTomorrow() {
    const dateObj = getCurrentDateObj();
    return new Date(dateObj.setDate(dateObj.getDate() + 1));
}
export function getNextWeekDateObj() {
    const dateObj = getCurrentDateObj();
    return new Date(dateObj.setDate(dateObj.getDate() + 7));
}
export function getStartOfWeek(dateString) {
    const dateObj = new Date(dateString);
    const day = getCorrectDay(dateString);
    return new Date(dateObj.setDate(dateObj.getDate() - day));
}
export function getEndOfWeek(dateString) {
    const dateObj = new Date(dateString);
    const day = getCorrectDay(dateString);
    const daysToSunday = 6 - day;
    return new Date(dateObj.setDate(dateObj.getDate() + daysToSunday));
}
export function getStartOfWeekend(dateString) {
    const dateObj = new Date(dateString);
    const day = getCorrectDay(dateString);
    const daysToSaturday = 5 - day;
    return new Date(dateObj.setDate(dateObj.getDate() + daysToSaturday));
}
export function getStartOfMonth(dateString) {
    const dateObj = new Date(dateString);
    return new Date(dateObj.getFullYear(), dateObj.getMonth(), 1);
}
export function getEndOfMonth(dateString) {
    const dateObj = new Date(dateString);
    return new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0);
}
export function getCorrectDay(dateString) {
    const dateObj = new Date(dateString);
    // 0: Sunday, 1: Monday... 6: Saturday
    const dayX = dateObj.getDay();
    // 0: Monday, 1: Tuesday... 6: Sunday
    const day = dayX ? dayX - 1 : 6;
    return day;
}
export function getDateString(dateObj) {
    const year = String(dateObj.getFullYear());
    let month = String(dateObj.getMonth() + 1);
    let date = String(dateObj.getDate());
    if (month.length < 2)
        month = '0' + month;
    if (date.length < 2)
        date = '0' + date;
    return `${year}-${month}-${date}`;
}
/**
 * @param dateFrom // 2023-09-11
 * @param dateTo // 2023-09-13
 * @param timeFrom // 09:30
 * @param timeTo // 10:30
 */
export function formatDateTimeRange(dateFrom, dateTo, timeFrom, timeTo) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateFrom || !dateFrom.match(regEx)) {
        return 'nezadáno';
    }
    if (!dateTo || !dateTo.match(regEx)) {
        dateTo = dateFrom;
    }
    const [yearFrom, monthFrom, dayFrom] = dateFrom.split('-');
    const [yearTo, monthTo, dayTo] = dateTo.split('-');
    const dateToFormatted = `${Number(dayTo)}. ${Number(monthTo)}. ${yearTo}`;
    if (timeFrom) {
        if (dateFrom !== dateTo) {
            const concatTimeTo = timeTo ? ` ${timeTo}` : '';
            return `${Number(dayFrom)}. ${Number(monthFrom)}. ${yearFrom} ${timeFrom} – ${dateToFormatted}${concatTimeTo}`;
        }
        if (timeTo && timeFrom !== timeTo) {
            return `${dateToFormatted} ${timeFrom}–${timeTo}`;
        }
        return `${dateToFormatted} ${timeFrom}`;
    }
    if (yearFrom !== yearTo) {
        return `${Number(dayFrom)}. ${Number(monthFrom)}. ${yearFrom} – ${dateToFormatted}`;
    }
    if (monthFrom !== monthTo) {
        return `${Number(dayFrom)}. ${Number(monthFrom)}. – ${dateToFormatted}`;
    }
    if (dayFrom !== dayTo) {
        return `${Number(dayFrom)}.–${dateToFormatted}`;
    }
    return `${dateToFormatted}`;
}
